import { post } from "shared-utils";

const OUTPUT_VERSION = "v3";

// Consider codegen
export interface DashboardMetadata {
  supports_profit_analysis: boolean;
  supports_any_refund_information: boolean;
  supports_item_level_refund_information: boolean;
  supports_refunds_by_refunded_date: boolean;
  google_ads_connected: boolean;
  meta_ads_connected: boolean;
  tiktok_ads_connected: boolean;
  multiple_stores_connected: boolean;
  all_connection_ids: number[];
  connected_connection_ids: number[];
}

export const getEmptyMetadata = (): DashboardMetadata => {
  return {
    supports_profit_analysis: false,
    supports_refunds_by_refunded_date: false,
    supports_item_level_refund_information: false,
    supports_any_refund_information: false,
    google_ads_connected: false,
    meta_ads_connected: false,
    tiktok_ads_connected: false,
    multiple_stores_connected: false,
    all_connection_ids: [],
    connected_connection_ids: [],
  };
};

export default function fetchDashboardMetaData(
  dashboardDataPath: string,
  onSuccess: (data: DashboardMetadata) => any,
  onFailure: (failureMessage: string) => any
) {
  post(
    dashboardDataPath,
    {
      version: OUTPUT_VERSION,
      dataPrefix: "metadata",
      timeRange: "TO_DATE",
      partitionDimensions: [],
      groupByDimensions: [],
      filterDimensions: [],
      filterMetrics: [],
    },
    onSuccess,
    onFailure
  );
}
